import { Button } from '@material-tailwind/react';
import { useEffect, useRef, useState } from 'react';
import { P } from "../../../components/typography/typography";
import { useNavigate } from "react-router-dom";
import statesService from '../../../Services/states.service';
import insuranceServices from '../../../Services/insurance.services';
import credentialService from '../../../Services/credential.services';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import 'react-toastify/dist/ReactToastify.css';



const formValues = {
  stateID: '',
}

const addInsuranceRequestSchema = Yup.object({
  stateID: Yup.string().required('Please select a state'),
  insuranceId: Yup.array().required('Please select a insurance')
})

const CreateInsuranceRequestInitial = (props: any) => {

  const [state, newState] = useState([{
    id: '',
    name: '',
    abbreviation: ''
  }]);
  const [selectedState, setSelectedState] = useState({
    id: '',
    name: '',
    abbreviation: ''
  });
  const [insuranceRequest, setInsuranceRequest] = useState();
  const [isStateListOpen, setIsStateListOpen] = useState(false);
  const [stateSearchTerm, setStateSearchTerm] = useState('');
  const stateDropdownRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();



  useEffect(() => {
    const getStateList = async () => {
      try {
        const result = await statesService.GetStates()
        newState(result)
      } catch (error) {
        throw error
      }
    }
    getStateList()
  }, [])

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (stateDropdownRef.current && !stateDropdownRef.current.contains(event.target as Node)) {
        setIsStateListOpen(false)
        setStateSearchTerm('')
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const filteredStates = state.filter((stt) =>
    stt.name.toLowerCase().includes(stateSearchTerm.toLowerCase())
  )

  const selectStateOption = (stt: { id: string; name: string; abbreviation: string }) => {
    stateChangeHandle(stt.id)
    setFieldValue('stateID', String(stt.id))
    setIsStateListOpen(false)
    setStateSearchTerm('')
  }


  const { errors, handleSubmit, setFieldValue, resetForm } = useFormik({
    initialValues: formValues,
    // validationSchema: addInsuranceRequestSchema,
    onSubmit: () => {
      createInsuranceRequest()
      resetForm()
    },
  })
  const stateChangeHandle = (stateId: any) => {
    var objSelectedStt = state.filter((stt) => String(stt.id) === String(stateId))
    objSelectedStt.map((stt) => {
      setSelectedState(stt)
    })

    //setFieldValue('stateID', ''+stateId)
  }

  const createInsuranceRequest = async () => {

    try {
      const resultState = await insuranceServices.PostInsuranceRequestState(selectedState)
      //setInsuranceRequest(resultState)
      localStorage.setItem('insuranceRequesteState', JSON.stringify(resultState))
      let url = await credentialService.GetNextPage();
      navigate("/"+url, { replace: true });
    } catch (error) {
      throw error
    }
  }



  const { heading, description, buttonName } = props
  return (
    <div>

          <div className="inset-0 p-8">
            <div className="flex min-h-full p-4 justify-center p-4 text-center">
                <form className="mt-6" onSubmit={handleSubmit}>
                      <h1 className="font-medium leading-tight text-2xl mt-0 mb-2 text-black-600">{heading}</h1>
                      <div className="relative p-6 flex-auto">
                        <p className="my-4 text-slate-500 leading-relaxed">
                          {description}
                        </p>
                        <div className="mb-4">
                          <div className="dropdown relative" ref={stateDropdownRef}>
                            <label className="absolute -top-2 left-3 z-10 bg-white px-1 text-xs font-medium text-blue-500">
                              State
                            </label>
                            <div
                              className={`flex w-full cursor-pointer items-center justify-between rounded-md border px-3 py-2.5 text-sm ${isStateListOpen ? 'border-blue-500' : 'border-gray-300'}`}
                              onClick={() => setIsStateListOpen((prev) => !prev)}
                            >
                              <span className={selectedState.name ? 'text-black' : 'text-gray-400'}>
                                {selectedState.name || 'Select a state'}
                              </span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                                className={`h-4 w-4 text-gray-500 transition-transform ${isStateListOpen ? 'rotate-180' : ''}`}
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </div>
                            {isStateListOpen && (
                              <div className="absolute z-20 mt-1 max-h-72 w-full overflow-y-auto rounded-md border border-gray-200 bg-white shadow-lg">
                                <div className="sticky top-0 border-b border-gray-100 bg-white p-2">
                                  <input
                                    type="text"
                                    autoFocus
                                    value={stateSearchTerm}
                                    onChange={(e) => setStateSearchTerm(e.target.value)}
                                    placeholder="Search state..."
                                    className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:outline-none"
                                  />
                                </div>
                                {filteredStates.length > 0 ? (
                                  filteredStates.map((stt) => (
                                    <div
                                      key={stt.id}
                                      onClick={() => selectStateOption(stt)}
                                      className={`cursor-pointer px-4 py-2 text-left text-sm hover:bg-blue-50 ${String(selectedState.id) === String(stt.id) ? 'bg-blue-50 font-medium' : ''}`}
                                    >
                                      {stt.name}
                                    </div>
                                  ))
                                ) : (
                                  <div className="px-4 py-2 text-sm text-gray-500">No states found</div>
                                )}
                              </div>
                            )}
                            {errors?.stateID && <P className="text-red-600">{errors.stateID}</P>}
                          </div>
                        </div>

                      </div>
                      {/*footer*/}

                    <div className="flex justify-end p-6 border-t border-solid border-slate-200 rounded-b">
                      <div className="modal-footer">
                        <Button
                          className="flex items-center"
                          type='submit'

                        >
                          {buttonName}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                            className="w-6 h-6"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
                            />
                          </svg>
                        </Button>

                      </div>
                    </div>
                </form>
            </div>
          </div>
    </div>
  )
}
export default CreateInsuranceRequestInitial